import { useContext } from "react";
import { StudentPageContext } from "../contexts/studentPageContext";

const useStudentPageContext = () => useContext(StudentPageContext);

export { useStudentPageContext };
